// The preview is sorted by event time; delta events are delivered by notification ID.
// Keep the two separate so backdated alarms can notify without displacing newer rows.
export function alarmPollState(data, priorIds, initial) {
  const list = Array.isArray(data) ? data : (data?.list || [])
  const idOf = item => item.notification_id ?? item.id
  const ids = new Set(list.map(idOf))
  const events = initial ? [] : Array.isArray(data?.new_events)
    ? data.new_events : list.filter(item => !priorIds.has(idOf(item)))
  return {
    list, ids, events,
    total: data?.total ?? list.length,
    next: Number.isSafeInteger(data?.next_id) ? data.next_id : null
  }
}

// Older backends return the full inbox even when asked for counts. This fallback
// lets the UI roll out independently without counting recovery messages as alarms.
export function alarmOverviewCounts(data, day, triggerType) {
  if (Number.isInteger(data?.triggers) && Number.isInteger(data?.today)) return data
  const list = Array.isArray(data) ? data : (data?.list || [])
  const triggers = list.filter(item => !item.event_type || item.event_type === triggerType)
  return { triggers: triggers.length, today: triggers.filter(item =>
    String(item.event_time || item.trigger_time || '').slice(0, 10) === day).length }
}
